<template>
  <v-card flat class="mx-auto mt-8">
    <v-card-text
      class="text-md-h3 text-sm-h4 text-h4 mt-md-12 mt-4 text-center font-weight-medium"
      :style="`color:${partnerColorDarkmode}`"
    >
      {{ $t("components.thg.ThgPriceOverview.title") }}
    </v-card-text>
    <v-row>
      <v-col cols="6" md="3" v-for="(item, i2) in items" :key="i2">
        <thg-price-card :price="item.price" :title="item.title" :subtitle="item.subTitle" :src="item.src" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import ThgPriceCard from "@/components/thg/ThgPriceCard.vue";
import { Component, Vue } from "vue-property-decorator";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";

@Component({
  components: {
    ThgPriceCard
  }
})
export default class ThgPriceOverview extends Vue {
  get items() {
    return [
      {
        title: "components.thg.ThgPriceOverview.car.title",
        subTitle: "components.thg.ThgPriceOverview.car.subTitle",
        src: "https://static.mmmint.ai/wirkaufendeinethg/electric_car.png",
        price: "350€"
      },
      {
        title: "components.thg.ThgPriceOverview.scooter.title",
        subTitle: "components.thg.ThgPriceOverview.scooter.subTitle",
        src: "https://static.mmmint.ai/wirkaufendeinethg/electric_scooter.png",
        price: "350€"
      },
      {
        title: "components.thg.ThgPriceOverview.truck.title",
        subTitle: "components.thg.ThgPriceOverview.truck.subTitle",
        src: "https://www.wirkaufendeinethg.de/images/options/electric_truck.png",
        price: "530€"
      },
      {
        title: "components.thg.ThgPriceOverview.bus.title",
        subTitle: "components.thg.ThgPriceOverview.bus.subTitle",
        src: "https://www.wirkaufendeinethg.de/images/options/electric_bus.png",
        price: "12.650€"
      }
    ];
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get partnerColorDarkmode() {
    return this.$vuetify.theme.dark ? "white" : this.color;
  }
}
</script>
